import React from 'react';
import ReactDOM from 'react-dom';
import { Marker } from 'google-maps-react';

function MarkerConfigured(props) {

  const ModalDenuncia = ({ divRemoved }) => (
    <>
      <div className="modal-denuncia-header">
        <div>
          <h4>{props.dados.vulnerabilidade}</h4>
          <button onClick={() => document.body.removeChild(divRemoved)}><strong>X</strong></button>
        </div>
        <p>{props.dados.data} - {props.dados.periodo}</p>
        <strong>ANÔNIMO</strong>
      </div>
      <div className="modal-denuncia-descricao">
        <p>{props.dados.descricao}</p>
      </div>
      <div className="modal-denuncia-footer">
        <p>Você é o responsável ou gestor da instituição citada?</p>
        <p>Você tem direito de resposta!</p>
        <button>CLIQUE AQUI</button>
      </div>
    </>
  );

  function createModal(){
    const div = document.createElement('div');
    div.className = 'modal-denuncia';

    ReactDOM.render(<ModalDenuncia divRemoved={div} />, div);

    document.body.appendChild(div);
  }

  return (
    <Marker
        {...props}
        google={props.google}
        title={'Denuncia'}
        position={{lat: props.dados.coordenadas.latitude, lng: props.dados.coordenadas.longitude}}
        onClick={() => createModal()}
    >
    </Marker>
  );
}

export default MarkerConfigured;